import * as React from 'react';
import { SVGProps } from 'react';
const TimePickerArrowDownMobileIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#569DE5"
      d="m11.42 23.562 8.349-8.348c.238-.238.369-.555.369-.894 0-.34-.131-.656-.37-.895l-.758-.758a1.28 1.28 0 0 0-1.8 0l-4.88 4.87V2.065c0-.697-.546-1.249-1.244-1.249h-1.071c-.698 0-1.3.552-1.3 1.25v15.527l-4.907-4.925a1.237 1.237 0 0 0-.887-.37c-.338 0-.652.131-.89.37l-.755.757a1.255 1.255 0 0 0-.369.895c0 .339.132.656.37.895l8.348 8.347c.24.24.558.37.897.37.34 0 .66-.13.899-.37Z"
    />
  </svg>
);
export default TimePickerArrowDownMobileIcon;
